



























import Vue from 'vue';
import scheduleRuleVuex from '../../../vuex/common';
import commonClient from '../../../../common/apis';

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  data() {
    return {
      name: null,
      isTipConfirmed: false,
    };
  },
  methods: {
    confirm() {
      if (this.name && this.name.trim() !== '') {
        this.$emit('save', this.name.trim());
        if (!this.isTipConfirmed) {
          this.$store.commit('SHOW_WX_TPL_TEMPLATE_TIP');
        }
      } else {
        this.$Message.warning('请填写模板名称');
      }
    },
    checkTipStatus() {
      commonClient.isCrmTipConfirmed({
        scene: 'wx_tpl_template',
      }).success((r: boolean) => {
        this.isTipConfirmed = r;
      });
    },
  },
  mounted() {
    this.checkTipStatus();
  },
});
